import { motion, AnimatePresence } from 'framer-motion';
import { useLocation } from 'react-router-dom';
import { isNative } from '@/lib/platform';
import { ReactNode } from 'react';

const nativeVariants = {
  initial: { x: '100%', opacity: 1 },
  animate: {
    x: 0,
    opacity: 1,
    transition: { type: 'tween', duration: 0.28, ease: [0.25, 0.46, 0.45, 0.94] },
  },
  exit: {
    x: '-30%',
    opacity: 0,
    transition: { type: 'tween', duration: 0.22, ease: 'easeIn' },
  },
};

const webVariants = {
  initial: { opacity: 1 },
  animate: { opacity: 1 },
  exit: { opacity: 1 },
};

interface Props {
  children: ReactNode;
}

export default function NativePageTransition({ children }: Props) {
  const location = useLocation();
  const variants = isNative ? nativeVariants : webVariants;

  if (!isNative) {
    // Web: render children directly — no wrapper, no animation, zero impact
    return <>{children}</>;
  }

  return (
    <AnimatePresence mode="wait" initial={false}>
      <motion.div
        key={location.pathname}
        variants={variants}
        initial="initial"
        animate="animate"
        exit="exit"
        style={{ width: '100%', minHeight: '100%' }}
      >
        {children}
      </motion.div>
    </AnimatePresence>
  );
}
